var _a;
import React from 'react';
import { ALERT_BANNER_TYPES, AlertBanner } from '@soluto-private/mx-asurion-ui-react';
import { ErrorType } from '../../services/ErrorService';
import { Locale } from '../../common/Constants';
import { getLocalisedErrorDisplay } from '../Internationalization';
var ErrorBannerType = (_a = {},
    _a[ErrorType.NonRetriable] = ALERT_BANNER_TYPES[2],
    _a[ErrorType.Retriable] = ALERT_BANNER_TYPES[3],
    _a[ErrorType.SystemError] = ALERT_BANNER_TYPES[2],
    _a);
var getLocalisedErrorMessage = function (errorType, locale) {
    if (locale === void 0) { locale = Locale.US; }
    var errorDisplay = getLocalisedErrorDisplay(locale);
    return errorDisplay.ErrorVerbiage[errorType];
};
export var ErrorMessage = function (props) {
    if (!(props === null || props === void 0 ? void 0 : props.error)) {
        return React.createElement(React.Fragment, null);
    }
    var bannerType = ErrorBannerType[props.error.type];
    var bannerMessage = getLocalisedErrorMessage(props.error.type, props.locale);
    return (React.createElement(React.Fragment, null,
        React.createElement(AlertBanner, { isOpen: !!props.error, alertBannerType: bannerType, onCloseClick: props.onClose }, bannerMessage)));
};
